import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/axiosClient/types';
import { RootState } from 'src/store';
import { GetBlocklistParams, BlocklistItem } from '../types';
import { BlocklistState } from './types';

const initialState: BlocklistState = {
  loading: {
    getList: false,
    create: false,
    update: false,
    delete: false,
  },
  filter: {
    companyId: '',
    offset: 0,
    limit: 25,
    page: 0,
  },
  list: null,
  error: null,
};

const blocklistSlice = createSlice({
  name: 'blocklist',
  initialState,
  reducers: {
    setLoading: (
      state,
      action: PayloadAction<Partial<Record<keyof BlocklistState['loading'], boolean>>>,
    ) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<GetBlocklistParams>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: BlocklistItem[];
        count: number;
      }>,
    ) => {
      state.list = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: state => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetError: state => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      return initialState;
    },
  },
});

export const { setLoading, setFilter, setList, setError, resetList, resetError, resetSlice } =
  blocklistSlice.actions;

export const isBlocklistLoading = (state: RootState) => state.blocklist?.loading;
export const getBlocklistData = (state: RootState) => state.blocklist?.list;
export const getBlocklistFilter = (state: RootState) => state.blocklist?.filter;
export const getBlocklistError = (state: RootState) => state.blocklist?.error;

export const blocklistReducer = blocklistSlice.reducer;
export default blocklistSlice.reducer;
